const envApiUrl = process.env.REACT_APP_API_URL?.trim();

const getFallbackApiUrl = () => {
	if (typeof window !== "undefined") {
		const host = window.location.hostname.toLowerCase();

		if (host === "localhost" || host === "127.0.0.1") {
			return "http://localhost:8000/api";
		}
	}

	return process.env.NODE_ENV === "development"
		? "http://localhost:8000/api"
		: "https://api.ammachekku.com/api";
};

const Config_Api = (envApiUrl || getFallbackApiUrl()).replace(/\/+$/, "");

export default Config_Api;
